// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import CheckOrderConstraintBuildWeek from './checkOrderConstraintBuildWeek';
import React from 'react';

function CheckOrderConstraintBuildWeeksPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-check-orders-constraint-build-week-page">
            <CheckOrderConstraintBuildWeek />
        </AuthenticatedPage>
    );

}
CheckOrderConstraintBuildWeeksPage.displayNAme = 'CheckOrderConstraintBuildWeeskPage';

export default CheckOrderConstraintBuildWeeksPage;
